import { PropsWithChildren } from 'react'
import { HighlightBasePositionProps } from './HighlightTypes'
import { useHighlightPositon } from './useHighlightPositon'
import { useMouseBubbleEvents } from './useMouseBubbleEvents'

export function SVGHighlight(
  props: PropsWithChildren<HighlightBasePositionProps>,
) {
  const { onWheel, onMouseDown, onMouseMove, onMouseUp } = useMouseBubbleEvents(
    props.divRef,
  )

  const { styles, height, width, viewBox } = useHighlightPositon(
    props.scale,
    props.position,
    props.imgWidth,
    props.imgHeight,
    props.rotation,
    props.paddingTopFix,
  )

  return (
    <svg
      style={styles}
      height={height}
      width={width}
      viewBox={viewBox}
      onWheel={onWheel}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur">
            <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur">
              <animate
                attributeName="stdDeviation"
                values="2;4;2"
                dur="2s"
                repeatCount="indefinite"
              />
            </feGaussianBlur>
          </feGaussianBlur>
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {props.children}
    </svg>
  )
}
